module.exports = __webpack_public_path__ + "static/media/partner_7_logo.38fed4ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner_7_logo.png
// module id = 1218
// module chunks = 0